import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Mise à jour de la TVA ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Taux de TVA : ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_number_format = _resolveComponent("number-format")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.parameters.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameters.visible) = $event)),
      closable: true,
      centered: true,
      "destroy-on-close": true,
      width: 350
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_row, { type: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              align: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "btn-warning",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  title: "Êtes-vous sûr de vouloir mettre à jour la TVA ?",
                  "ok-text": "Oui",
                  "cancel-text": "Annuler",
                  onConfirm: _ctx.setTva
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit",
                      disabled: _ctx.disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mettre à jour ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, { direction: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, { type: "warning" }, {
              message: _withCtx(() => [
                _createTextVNode(" La mise à jour de la TVA entraînera l'écrasement des TVA de cette catégorie ! ")
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_component_a_select, {
                value: _ctx.tvaId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tvaId) = $event)),
                style: {"width":"180px"},
                placeholder: "Sélectionner une TVA"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tvas, (tva) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: tva.tvaId,
                      value: tva.tvaId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_number_format, {
                          value: tva.taux,
                          options: _ctx.percentageValueOptions
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}